import { IGlobalState, GlobalActionTypeList, GlobalAction } from './GlobalState'
import { getPlayheadDataFromTime, getPlayheadDataFromPosition } from './utils'
import { addEdge, applyNodeChanges, applyEdgeChanges } from '@xyflow/react'
export const GlobalStateReducer = (state: IGlobalState, action: GlobalAction): IGlobalState => {
  switch (action.type) {
    case GlobalActionTypeList.SetControlIsPlaying:
      return { ...state, control: { ...state.control, isPlaying: action.payload } }
    case GlobalActionTypeList.SetControlPlayheadPosition:
      return { ...state, control: { ...state.control, playheadPosition: action.payload } }
    case GlobalActionTypeList.SetControlPlayheadTime:
      return { ...state, control: { ...state.control, playheadTime: action.payload } }
    case GlobalActionTypeList.SetControlBpm:
      return { ...state, control: { ...state.control, bpm: action.payload } }
    case GlobalActionTypeList.SetControlSignatureNumerator:
      return { ...state, control: { ...state.control, signature: { ...state.control.signature, numerator: action.payload } } }
    case GlobalActionTypeList.SetControlSignatureDenominator:
      return { ...state, control: { ...state.control, signature: { ...state.control.signature, denominator: action.payload } } }
    case GlobalActionTypeList.SetControlRepeatIsActive:
      return { ...state, control: { ...state.control, repeat: { ...state.control.repeat, isActive: action.payload } } }
    case GlobalActionTypeList.SetControlRepeatFrom:
      return { ...state, control: { ...state.control, repeat: { ...state.control.repeat, from: action.payload } } }
    case GlobalActionTypeList.SetControlRepeatTo:
      return { ...state, control: { ...state.control, repeat: { ...state.control.repeat, to: action.payload } } }
    case GlobalActionTypeList.SetEditorTargetId:
      return { ...state, editor: { ...state.editor, targetId: state.editor.targetId === action.payload ? '' : action.payload } }
    case GlobalActionTypeList.SetEditorQuantizationNumerator:
      return { ...state, editor: { ...state.editor, quantization: { ...state.editor.quantization, numerator: action.payload } } }
    case GlobalActionTypeList.SetEditorQuantizationDenominator:
      return { ...state, editor: { ...state.editor, quantization: { ...state.editor.quantization, denominator: action.payload } } }
    case GlobalActionTypeList.SetEditorQuantizationIsActive:
      return { ...state, editor: { ...state.editor, quantization: { ...state.editor.quantization, isActive: action.payload } } }
    case GlobalActionTypeList.SetEditorTimelineZoom:
      return { ...state, editor: { ...state.editor, timeline: { ...state.editor.timeline, zoom: action.payload } } }
    case GlobalActionTypeList.SetNodes:
      return { ...state, nodes: action.payload }
    case GlobalActionTypeList.SetEdges:
      return { ...state, edges: action.payload }
    case GlobalActionTypeList.AddNode:
      return { ...state, nodes: [...state.nodes, action.payload] }
    case GlobalActionTypeList.AddEdge:
      return { ...state, edges: addEdge(action.payload, state.edges) }
    case GlobalActionTypeList.UpdateNodeById:
      return { ...state, nodes: state.nodes.map(n => n.id === action.payload.id ? action.payload : n) }
    case GlobalActionTypeList.RemoveNode:
      return { ...state, nodes: state.nodes.filter(n => n.id !== action.payload) }
    case GlobalActionTypeList.RemoveEdge:
      return { ...state, edges: state.edges.filter(e => e.id !== action.payload) }
    case GlobalActionTypeList.UpdateNodes:
      return { ...state, nodes: applyNodeChanges(action.payload, state.nodes) }
    case GlobalActionTypeList.UpdateEdges:
      return { ...state, edges: applyEdgeChanges(action.payload, state.edges) }
    case GlobalActionTypeList.AddSequence:
      return { ...state, sequences: [...state.sequences, action.payload] }
    case GlobalActionTypeList.UpdateSequenceById:
      return { ...state, sequences: state.sequences.map(s => s.id === action.payload.id ? action.payload : s) }
    case GlobalActionTypeList.RemoveSequence:
      return { ...state, sequences: state.sequences.filter(s => s.id !== action.payload) }
    case GlobalActionTypeList.UpdateSequences:
      return { ...state, sequences: action.payload }
    case GlobalActionTypeList.AddSequenceNote:
      return { ...state, sequences: state.sequences.map(s => s.id === action.payload.sequenceId ? { ...s, notes: [...s.notes, action.payload.note] } : s) }
    case GlobalActionTypeList.UpdateSequenceNoteById:
      return { ...state, sequences: state.sequences.map(s => s.id === action.payload.sequenceId ? { ...s, notes: s.notes.map(n => n.id === action.payload.note.id ? action.payload.note : n) } : s) }
    case GlobalActionTypeList.RemoveSequenceNote:
      return { ...state, sequences: state.sequences.map(s => s.id === action.payload.sequenceId ? { ...s, notes: s.notes.filter(n => n.id !== action.payload.noteId) } : s) }
    case GlobalActionTypeList.UpdateSequenceNotes:
      return { ...state, sequences: state.sequences.map(s => s.id === action.payload.sequenceId ? { ...s, notes: action.payload.notes } : s) }
    case GlobalActionTypeList.SetAll:
      return action.payload
    default:
      return state;
  }
};

export const initialGlobalState: IGlobalState = {
  control: {
    isPlaying: false,
    playheadTime: 0,
    playheadPosition: {
      bar: 1,
      beat: 1
    },
    bpm: 120,
    signature: {
      numerator: 4,
      denominator: 4
    },
    repeat: {
      isActive: false,
      from: {
        bar: 1,
        beat: 1
      },
      to: {
        bar: 9,
        beat: 1
      }
    }
  },
  editor: {
    targetId: '',
    quantization: {
      isActive: true,
      numerator: 1,
      denominator: 8
    },
    timeline: {
      zoom: 1
    }
  },
  nodes: [],
  edges: [],
  sequences: []
};
